<div class="card card-nb h-100 w-100">
  <div class="card-body p-4 w-100">
    <h2 class="mb-2">{{ "subscription_reference_headline" | i18next }}</h2>
    <div class="d-flex flex-column">
      <div class="mb-3"
      [innerHTML]="'subscription_reference_active_description' | i18next: { reference }"></div>
      <div class="mb-3">
        <i class="fa fa-info-circle red mr-2"></i>
        <span class="subinformations">{{ "subscription_reference_description" | i18next }}</span>
      </div>
    </div>
    @if (!isEdit) {
      <div class="d-flex mt-auto w-100 justify-content-end mt-3">
        <button
          name="subscription-invoice-format-edit"
          class="btn btn-outline-primary"
          (click)="edit()">
          {{ 'subscription_reference_edit_button'|i18next }}
        </button>
      </div>
    }
    @if (isEdit) {
      <div>
        <app-subscription-reference-form
          [referencePlaceholder]="reference"
          [reference]="reference"
          [required]="true"
          (formSubmit)="onSave($event)"
          >
          <button name="subscription-invoice-format-cancel" class="btn btn-link"
            (click)="cancel()">
            {{'app_cancel'|i18next}}
          </button>
        </app-subscription-reference-form>
      </div>
    }
  </div>
</div>
